import { AcademyCourse } from '../../models/academy-course.model';

export const trialLessonCourse: AcademyCourse = {
  slug: 'do-a-trial-lesson',
  trainingModuleId: 'trial_lesson',
  titleKey: 'texts.Tutor_Academy_Course_Trial_Lesson_Title',
  descriptionKey: 'texts.Tutor_Academy_Course_Trial_Lesson_Description',
  isMandatory: false,
  hasSearchBoost: true,
  lessons: [
    {
      id: 'zo-ziet-een-proefles-eruit',
      titleKey: 'texts.Tutor_Academy_TrialLesson_L1_Title',
      subtitleKey: 'texts.Tutor_Academy_TrialLesson_L1_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L1_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L1_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_TrialLesson_L1_Item1',
            'texts.Tutor_Academy_TrialLesson_L1_Item2',
            'texts.Tutor_Academy_TrialLesson_L1_Item3',
            'texts.Tutor_Academy_TrialLesson_L1_Item4'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L1_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L1_Paragraph4' },
        {
          type: 'paragraph',
          textKey: 'texts.Tutor_Academy_TrialLesson_L1_Paragraph5',
          linkLabelKey: 'texts.Tutor_Academy_TrialLesson_L1_Manual_Label',
          linkParam: 'manual',
          linkUrlKey: 'texts.Tutor_Academy_TrialLesson_Guide_Url'
        }
      ]
    },
    {
      id: 'neem-de-leiding',
      titleKey: 'texts.Tutor_Academy_TrialLesson_L2_Title',
      subtitleKey: 'texts.Tutor_Academy_TrialLesson_L2_Subtitle',
      headingKey: 'texts.Tutor_Academy_TrialLesson_L2_Heading',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L2_Paragraph1' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_TrialLesson_L2_Item1',
            'texts.Tutor_Academy_TrialLesson_L2_Item2',
            'texts.Tutor_Academy_TrialLesson_L2_Item3'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L2_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L2_Paragraph3' }
      ]
    },
    {
      id: 'vat-samen-en-verbind',
      titleKey: 'texts.Tutor_Academy_TrialLesson_L3_Title',
      subtitleKey: 'texts.Tutor_Academy_TrialLesson_L3_Subtitle',
      headingKey: 'texts.Tutor_Academy_TrialLesson_L3_Heading',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L3_Paragraph1' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_TrialLesson_L3_Item1',
            'texts.Tutor_Academy_TrialLesson_L3_Item2',
            'texts.Tutor_Academy_TrialLesson_L3_Item3',
            'texts.Tutor_Academy_TrialLesson_L3_Item4'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L3_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L3_Paragraph3' }
      ]
    },
    {
      id: 'sluit-af-met-een-dag',
      titleKey: 'texts.Tutor_Academy_TrialLesson_L4_Title',
      subtitleKey: 'texts.Tutor_Academy_TrialLesson_L4_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L4_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L4_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_TrialLesson_L4_Item1',
            'texts.Tutor_Academy_TrialLesson_L4_Item2',
            'texts.Tutor_Academy_TrialLesson_L4_Item3'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L4_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L4_Paragraph4' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_TrialLesson_L4_Paragraph5' }
      ]
    }
  ],
  quiz: [
    {
      id: 'duur-en-deelnemers',
      questionKey: 'texts.Tutor_Academy_TrialLesson_Q1_Question',
      isMultiSelect: false,
      answers: [
        { id: 'een-uur', textKey: 'texts.Tutor_Academy_TrialLesson_Q1_Answer1' },
        { id: 'dertig-minuten', textKey: 'texts.Tutor_Academy_TrialLesson_Q1_Answer2' }
      ],
      correctAnswerIds: ['dertig-minuten'],
      explanationKey: 'texts.Tutor_Academy_TrialLesson_Q1_Explanation'
    },
    {
      id: 'diagnose',
      questionKey: 'texts.Tutor_Academy_TrialLesson_Q2_Question',
      isMultiSelect: false,
      answers: [
        { id: 'meteen-uitleggen', textKey: 'texts.Tutor_Academy_TrialLesson_Q2_Answer1' },
        { id: 'doorvragen', textKey: 'texts.Tutor_Academy_TrialLesson_Q2_Answer2' }
      ],
      correctAnswerIds: ['doorvragen'],
      explanationKey: 'texts.Tutor_Academy_TrialLesson_Q2_Explanation'
    },
    {
      id: 'afsluiten',
      questionKey: 'texts.Tutor_Academy_TrialLesson_Q3_Question',
      isMultiSelect: true,
      answers: [
        { id: 'dag-noemen', textKey: 'texts.Tutor_Academy_TrialLesson_Q3_Answer1' },
        { id: 'laat-maar-weten', textKey: 'texts.Tutor_Academy_TrialLesson_Q3_Answer2' },
        { id: 'agenda-kijken', textKey: 'texts.Tutor_Academy_TrialLesson_Q3_Answer3' },
        { id: 'berichtje-sturen', textKey: 'texts.Tutor_Academy_TrialLesson_Q3_Answer4' }
      ],
      correctAnswerIds: ['dag-noemen'],
      explanationKey: 'texts.Tutor_Academy_TrialLesson_Q3_Explanation'
    },
    {
      id: 'overleggen',
      questionKey: 'texts.Tutor_Academy_TrialLesson_Q4_Question',
      isMultiSelect: false,
      answers: [
        { id: 'afwachten', textKey: 'texts.Tutor_Academy_TrialLesson_Q4_Answer1' },
        { id: 'dag-voorstellen', textKey: 'texts.Tutor_Academy_TrialLesson_Q4_Answer2' }
      ],
      correctAnswerIds: ['dag-voorstellen'],
      explanationKey: 'texts.Tutor_Academy_TrialLesson_Q4_Explanation'
    }
  ]
};
